module.exports = __webpack_public_path__ + "static/media/fig5.b3222aac.png";